import ReactDOM from 'react-dom/client'
import { BrowserRouter } from 'react-router-dom'
import 'bootstrap/dist/css/bootstrap.min.css'
import 'bootstrap/dist/js/bootstrap.bundle.min.js'
import { StructuraAuthProvider } from '@structura/auth'
import { I18nProvider } from '@structura/i18n'
import App from './App'
import '@structura/ui/globals.css'

const rootElement: HTMLElement | null = document.getElementById('root')
if (rootElement === null) {
  throw new Error('Unable to find root element for React application.')
}

const reactRoot = ReactDOM.createRoot(rootElement)

const application = (
  <I18nProvider defaultLanguage="nb">
    <BrowserRouter>
      <StructuraAuthProvider>
        <App />
      </StructuraAuthProvider>
    </BrowserRouter>
  </I18nProvider>
)

reactRoot.render(application)